import React from "react";
import { useMutation } from "react-query";
import { editInvoiceReconcilliation } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useEditInvoiceReconcilliation = () => {
  return useMutation(editInvoiceReconcilliation);
};

export default useEditInvoiceReconcilliation;
